import { render, staticRenderFns } from "./status-info.vue?vue&type=template&id=7d2d0c24&"
import script from "./status-info.vue?vue&type=script&lang=js&"
export * from "./status-info.vue?vue&type=script&lang=js&"
import style0 from "./status-info.vue?vue&type=style&index=0&id=7d2d0c24&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports